var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import Box from "@cloudscape-design/components/box";
import Link from "@cloudscape-design/components/link";
import Icon from "@cloudscape-design/components/icon";
import Input from "@cloudscape-design/components/input";
import Button from "@cloudscape-design/components/button";
import FormField from "@cloudscape-design/components/form-field";
import { concatenatePaths } from "../../utils";
import { useFileExplorerStore } from "../../store";
import { CenterContent } from "../../../center";
import { useMutation } from "react-query";
import * as cloudScapeDesignTokens from "@cloudscape-design/design-tokens";
import SpaceBetween from "@cloudscape-design/components/space-between";
/**
 * Displays the file icon and an editable input field along with submit and cancel actions.
 */
export var RenamingDisplayNameCell = function (_a) {
    var file = _a.file, actions = _a.actions, i18nStrings = _a.i18nStrings;
    var renamingFileNewName = useFileExplorerStore(function (state) { return state.renaming.newFileName; });
    var renameErrorMessage = useFileExplorerStore(function (s) { return s.renameErrorMessage; });
    var _b = useMutation(function () { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, actions.renameFile()];
                case 1:
                    _a.sent();
                    return [2 /*return*/];
            }
        });
    }); }), mutate = _b.mutate, isLoading = _b.isLoading;
    return (_jsxs(CenterContent, __assign({ vertical: true }, { children: [_jsx(Box, { children: _jsx(Icon, { name: file.type, "aria-label": i18nStrings[file.type] }) }), _jsx(Box, __assign({ padding: { left: "xs", right: "s", bottom: "xxs" } }, { children: _jsx(FormField, __assign({ errorText: renameErrorMessage, description: i18nStrings.newFileName, i18nStrings: { errorIconAriaLabel: i18nStrings.errorAriaLabel } }, { children: _jsx(Input, { ariaLabel: i18nStrings.newFileName, value: renamingFileNewName !== null && renamingFileNewName !== void 0 ? renamingFileNewName : "", autoFocus: true, onChange: function (e) {
                            useFileExplorerStore.setState({
                                renaming: __assign(__assign({}, useFileExplorerStore.getState().renaming), { newFileName: e.detail.value }),
                            });
                        }, onKeyUp: function (e) {
                            // Handle enter key
                            if (e.detail.key === "Enter") {
                                mutate();
                            }
                        } }) })) })), _jsxs(SpaceBetween, __assign({ size: "xxxs", direction: "horizontal" }, { children: [!isLoading && (_jsx(Button, { variant: "link", iconName: "close", onClick: function () {
                            actions.stopRenaming();
                        }, ariaLabel: i18nStrings.ignoreChanges })), _jsx(Button, { variant: "link", iconName: "check", loading: isLoading, onClick: function () {
                            mutate();
                        }, ariaLabel: i18nStrings.saveChanges })] }))] })));
};
/**
 * Displays the file icon and the file name as an editable input field along with submit and cancel actions.
 */
var DraftFolderCell = function (_a) {
    var file = _a.file, actions = _a.actions, i18nStrings = _a.i18nStrings;
    var newFolderName = useFileExplorerStore(function (state) { return state.newFolderName; });
    var createFolderErrorMessage = useFileExplorerStore(function (state) { return state.createFolderErrorMessage; });
    var _b = useMutation(function () { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, actions.createFolder()];
                case 1:
                    _a.sent();
                    return [2 /*return*/];
            }
        });
    }); }), mutate = _b.mutate, isLoading = _b.isLoading;
    return (_jsxs(CenterContent, __assign({ vertical: true }, { children: [_jsx(Icon, { name: file.type, "aria-label": i18nStrings[file.type] }), _jsx(Box, __assign({ padding: { left: "xs", right: "s", bottom: "xxs" } }, { children: _jsx(FormField, __assign({ errorText: createFolderErrorMessage, description: i18nStrings.newFolderName, i18nStrings: { errorIconAriaLabel: i18nStrings.errorAriaLabel } }, { children: _jsx(Input, { autoFocus: true, ariaLabel: i18nStrings.newFolderName, value: newFolderName !== null && newFolderName !== void 0 ? newFolderName : "", onChange: function (e) {
                            useFileExplorerStore.setState({
                                newFolderName: e.detail.value,
                            });
                        }, onKeyDown: function (e) {
                            // Handle enter key
                            if (e.detail.key === "Enter") {
                                mutate();
                            }
                        } }) })) })), _jsxs(SpaceBetween, __assign({ size: "xxxs", direction: "horizontal" }, { children: [!isLoading && (_jsx(Button, { variant: "link", iconName: "close", onClick: function () {
                            actions.stopCreatingFolder();
                        }, ariaLabel: i18nStrings.ignoreChanges })), _jsx(Button, { variant: "link", iconName: "check", loading: isLoading, onClick: function () {
                            mutate();
                        }, ariaLabel: i18nStrings.saveChanges })] }))] })));
};
/**
 * Displays the file icon and the file name.
 * If the file is a folder, the file name is a link that navigates to the folder.
 * If the file is a file, the file name is displayed as text.
 * If the file is a draft folder, the file name is an editable input field along with submit and cancel actions.
 * If the file or folder is being renamed, the file name is an editable input field along with submit and cancel actions.
 */
var DisplayNameCell = function (_a) {
    var allowedActions = _a.allowedActions, file = _a.file, actions = _a.actions, i18nStrings = _a.i18nStrings;
    var path = useFileExplorerStore(function (state) { var _a; return (_a = state.path) !== null && _a !== void 0 ? _a : ""; });
    if (file.isDraft) {
        return (_jsx(DraftFolderCell, { file: file, actions: actions, i18nStrings: i18nStrings }));
    }
    if (file.isRenaming) {
        return (_jsx(RenamingDisplayNameCell, { file: file, actions: actions, i18nStrings: i18nStrings }));
    }
    if (file.type === "folder") {
        return (_jsxs(_Fragment, { children: [_jsx(Icon, { name: "folder", "aria-label": i18nStrings[file.type] }), _jsx("span", { style: { marginRight: cloudScapeDesignTokens.spaceScaledXs } }), _jsx(Link, __assign({ ariaLabel: "".concat(i18nStrings.folder, " ").concat(file.displayName), onFollow: function () {
                        var newPath = concatenatePaths(path, file.displayName);
                        useFileExplorerStore.setState({
                            path: newPath,
                        });
                    } }, { children: " ".concat(file.displayName) }))] }));
    }
    // file.type === "file"
    if (allowedActions.download) {
        return (_jsxs(_Fragment, { children: [_jsx(Icon, { name: "file", "aria-label": i18nStrings[file.type] }), _jsx("span", { style: { marginRight: cloudScapeDesignTokens.spaceScaledXs } }), _jsx(Link, __assign({ ariaLabel: "".concat(i18nStrings.file, " ").concat(file.displayName), onFollow: function () { return __awaiter(void 0, void 0, void 0, function () {
                        return __generator(this, function (_a) {
                            switch (_a.label) {
                                case 0: return [4 /*yield*/, actions.downloadFiles([file])];
                                case 1:
                                    _a.sent();
                                    return [2 /*return*/];
                            }
                        });
                    }); } }, { children: file.displayName }))] }));
    }
    // file.type === "file" && download disabled
    return (_jsxs(_Fragment, { children: [_jsx(Icon, { name: "file", "aria-label": i18nStrings[file.type] }), _jsx("span", { style: { marginRight: cloudScapeDesignTokens.spaceScaledXs } }), _jsx("span", { children: file.displayName })] }));
};
export default DisplayNameCell;
